package one.healthium.insights.domain.shopping_list

data class ShoppingListDataModel(
    val id: String,
    val checkedIds: Set<String>,
)
